// constants/dependentMappings.js

export const DEPENDENT_CVT_CODES = {
  // Shared mappings for EHP/PEH/FEH
  EHP: {
    FATHER: {
      Dep_Code: 20059,
      Description: 'FATHER',
      CVT_Code: 2018588,
      AgeLimit: 74,
      genderOptions: ['MALE']
    },
    MOTHER: {
      Dep_Code: 200510,
      Description: 'MOTHER',
      CVT_Code: 2018587,
      AgeLimit: 74,
      genderOptions: ['FEMALE']
    },
    SPOUSE: {
      Dep_Code: 1001,
      Description: 'SPOUSE',
      CVT_Code: 2017469,
      AgeLimit: 64,
      genderOptions: ['MALE', 'FEMALE']
    },
    CHILD: {
      Dep_Code: 1002,
      Description: 'CHILD',
      CVT_Code: 2017471,
      AgeLimit: 23,
      genderOptions: ['MALE', 'FEMALE']
    },
    'MOTHER-IN-LAW': {
      Dep_Code: 201632,
      Description: 'MOTHER-IN-LAW',
      CVT_Code: 2018590,
      AgeLimit: 74,
      genderOptions: ['FEMALE']
    },
    'FATHER-IN-LAW': {
      Dep_Code: 201633,
      Description: 'FATHER-IN-LAW',
      CVT_Code: 2018589,
      AgeLimit: 74,
      genderOptions: ['MALE']
    },
    'EXTENDED-FAMILY': {
      Dep_Code: 201423,
      Description: 'EXTENDED-FAMILY',
      CVT_Code: 2017470,
      AgeLimit: 74,
      genderOptions: ['MALE', 'FEMALE']
    }
  },
  // PEH and FEH will use the same mappings as EHP
  PEH: {},
  FEH: {},
  // FPP Mappings (remains unique)
  FPP: {
    SPOUSE: {
      Dep_Code: 1001,
      Description: 'SPOUSE',
      CVT_Code: 2017462,
      AgeLimit: 55,
      genderOptions: ['MALE', 'FEMALE']
    },
    CHILD: {
      Dep_Code: 1002,
      Description: 'CHILD',
      CVT_Code: 2017461,
      AgeLimit: 18,
      genderOptions: ['MALE', 'FEMALE']
    }
  }
};

// Initialize PEH and FEH with the same mappings as EHP
DEPENDENT_CVT_CODES.PEH = DEPENDENT_CVT_CODES.EHP;
DEPENDENT_CVT_CODES.FEH = DEPENDENT_CVT_CODES.EHP;

export const MAX_CHILDREN = {
  EHP: 4,
  FEH: 4,
  PEH: 4,
  FPP: 4
};